import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/operator/routing/reject-lists")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: "/app/operator/routing",
      search: { view: "access-control" },
      hash: location.hash,
      replace: true,
    });
  },
});
